import { useState, useEffect } from "react";
import { useModal } from "../../hooks";
import LavorisService from "../../services/LavorisService";
import AddRRHHAbsentee from "../others/userModule/RRHHAbsentee/addRRHHAbsentee";
import EditRRHHAbsentee from "../others/userModule/RRHHAbsentee/editRRHHAbsentee";
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import { getUserRolesTableColumns } from "./userRolesTableColumns";


const ADD_RRHH_ABSENTEE_MODAL = "addRRHHAbsenteesModal";
const EDIT_RRHH_ABSENTEE_MODAL = "editRRHHAbsenteesModal";

const RRHHAbsentees = () => {
  const LavorisInstance = LavorisService.getInstance();

  // useStates
  const [tableLoading, setTableLoading] = useState(true);
  const { openModal, closeModal, isActive } = useModal();
  const [RRHHAbsentees, setRRHHAbsentees] = useState<any[]>([]);
  const [RRHHAbsentee, setRRHHAbsentee] = useState<any>(null);


  const getItems = async () => {
    setTableLoading(true);
    try {
      const response = await LavorisInstance.User.findUsersByRoleAlias(
        "RRHH_ABSENTEE",
      );
      setRRHHAbsentees(response);
    } catch (error) {
      console.log(error);
    } finally {
      setTableLoading(false);
    }
  }
  useEffect(() => {
    const getData = async () => {
      await getItems();
    };
    getData();
  }, []);

  // Configuración de columnas para la tabla
  const requestedTurnsColumns = getUserRolesTableColumns((rowData) => {
    openModal(EDIT_RRHH_ABSENTEE_MODAL, rowData.id);
    setRRHHAbsentee(rowData);
  });


  return (
    <>
      <div className="custom-header mt-sm-4 mt-0 pt-2">
        <div className="header-controls">
          {/* Search Section */}
          <div className="search-section">
          </div>

          {/* Actions Section */}
          <div className="actions-section">
            <button
              type="button"
              className="add-btn"
              onClick={() => {
                openModal(ADD_RRHH_ABSENTEE_MODAL);
              }}
              title="Agregar"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M8 3.333v9.334M3.333 8h9.334"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="btn-text">Agregar</span>
            </button>
          </div>
        </div>
      </div>

      <InfiniteTable
        data={RRHHAbsentees}
        columns={requestedTurnsColumns}
        loading={tableLoading}
        hasMore={false}
        onLoadMore={() => { }}
        height={300}
        emptyMessage="Momentáneamente no hay datos para mostrar"
        loadingMessage={RRHHAbsentees.length === 0 ? "Cargando datos..." : "Buscando más datos..."}
        striped
        hover
        bordered
      />


      {isActive(ADD_RRHH_ABSENTEE_MODAL) && (
        <AddRRHHAbsentee
          show
          urlTittle={ADD_RRHH_ABSENTEE_MODAL}
          onClose={() => closeModal(ADD_RRHH_ABSENTEE_MODAL)}
          modalTittle="Agregar RRHH de Ausentismos"
          tableLoading={getItems}
        />
      )}
      {isActive(EDIT_RRHH_ABSENTEE_MODAL) && (
        <EditRRHHAbsentee
          show
          urlTittle={EDIT_RRHH_ABSENTEE_MODAL}
          onClose={() => closeModal(EDIT_RRHH_ABSENTEE_MODAL)}
          modalTittle="Editar RRHH de Ausentismos"
          data={RRHHAbsentee}
          tableLoading={getItems}
        />
      )}
    </>
  );
};

export default RRHHAbsentees;
